/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import mainIcon from "../../content/assets/icon.png"

const SEO = ({ description, lang, meta, title }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            social { twitter }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:image`,
          content: `https://petslove.com.ua${mainIcon}`,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:image`,
          content: `https://petslove.com.ua${mainIcon}`,
        },
        {
          name: `twitter:creator`,
          content: 'petslove_com_ua',
        },
        {
          name: `twitter:site`,
          content: 'petslove_com_ua',
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <script type="application/ld+json">{ `{ "@context": "https://schema.org", "@type": "Blog", "url": "https://petslove.com.ua", "logo": "https://petslove.com.ua${mainIcon}" }` }</script>
      <script data-ad-client="ca-pub-8266792178446900" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
      </Helmet>
  )
}
// {
//   "@context": "https://schema.org/",
//   "@type": "Recipe",
//   "name": "Banana Bread Recipe",
//   "description": "The best banana bread recipe you'll ever find! Learn how to use up all those extra bananas.",
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "ratingValue": "4.7",
//     "ratingCount": "123"
//   },
//   "video": {
//     "@type": "VideoObject",
//     "name": "How To Make Banana Bread",
//     "description": "This is how you make banana bread, in 5 easy steps.",
//     "contentUrl": "http://www.example.com/video123.mp4"
//    }
// }
SEO.defaultProps = {
  lang: `uk`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
